import { BULK_ACTIONS } from '../../../constants/actionTypes';

const initialState = {
  success: null,
  inProgress: null,
  done: null,
  name: null,
  selected: [],
};

const selectedItemsReducer = (state = [], action) => {
  switch (action.type) {
    case BULK_ACTIONS.LIST.TOGGLE_ITEM: {
      const index = state.indexOf(action.index);
      if (index > -1) {
        return state.slice(0, index).concat(state.slice(index + 1));
      }
      return state.concat(action.index);
    }

    case BULK_ACTIONS.LIST.ADD_ALL:
      return action.indexes;

    case BULK_ACTIONS.LIST.REMOVE_ALL:
      return [];

    default:
      return state;
  }
};

export const bulkActionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case BULK_ACTIONS.SUBMIT.REQUEST:
      return _.extend({}, state, {
        inProgress: true,
        done: false,
        success: null,
        name: action.name,
        count: state.selected.length,
        lastSubmitted: action.lastSubmitted,
      });

    case BULK_ACTIONS.SUBMIT.SUCCESS:
      return _.extend({}, state, {
        inProgress: false,
        success: true,
        done: true,
      });

    case BULK_ACTIONS.MASS_ACTION.DONE:
      return {
        ...state,
        success: null,
        inProgress: null,
        done: null,
      };

    case BULK_ACTIONS.SUBMIT.DONE:
      return _.extend({}, state, initialState);

    case BULK_ACTIONS.SUBMIT.FAILURE:
      return _.extend({}, state, {
        inProgress: false,
        success: false,
        done: true,
      });

    case BULK_ACTIONS.LIST.TOGGLE_ITEM:
    case BULK_ACTIONS.LIST.ADD_ALL:
    case BULK_ACTIONS.LIST.REMOVE_ALL:
      return _.extend({}, state, {
        selected: selectedItemsReducer(state.selected, action),
      });

    default:
      return state;
  }
};
